import { BASE_URL } from "../BaseUrl";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = sessionStorage.getItem("token")
  if (token) {
    config.headers.Authorization =  `Bearer ${token}`;
  } else {
    config.headers.Authorization =  null;
  }

  return config;
});


export const getAffichePublicitaire = (emplacement, format) => {
  return BASE_URL(`recherchervisuelpublicite/${emplacement}/${format}`)
};

export const getUrlPublicitaire = async (emplacement) => {
  return await axios.get(
    BASE_URL(`rechercherurlpubparemplacement/${emplacement}`),
    {}
  );
};
